<template>
  <div>
    <h2 class="page-title-bar">
      <img src="@/assets/img/camera.png" style="margin-right: 10px; width:28px" />
      {{ $t("Device") }}
      ({{ $t("Camera") }})
    </h2>

    <v-row dense class="dashboard-row mt-5">
      <!-- LEFT CARD -->
      <v-col cols="6">
        <div class="dashboard-scroll">
          <v-card class="dashboard-box donut-card pa-6 flex-grow-1">
            <div class="card-title">{{ $t('Device Status') }}</div>

            <div class="device-wrapper">
              <!-- Donut -->
              <!-- <div class="donut-section">
                <apexchart type="donut" width="100%" height="220" :options="donutOptions" :series="donutSeries" />
              </div> -->
              <div class="donut-section">
                <template v-if="hasDonutData">
                  <apexchart type="donut" width="100%" height="220" :options="donutOptions" :series="donutSeries" />
                </template>
                <div v-else class="empty-chart-state">
                  <i class="mdi mdi-chart-bar empty-icon"></i>
                  <p class="empty-text">{{ $t('No data available') }}</p>
                </div>
              </div>

              <!-- Stats -->
              <div class="stats-section">
                <div class="stats-row px-3">
                  <div class="stat-block">
                    <div class="stat-label yellow-dot">{{ $t('Battery Bad') }}</div>
                    <div class="stat-value">{{ donutSeries[0] ? donutSeries[0] : '-' }}</div>
                    <!-- <div class="stat-sub">({{ lowBatteryPer }}%)</div> -->
                  </div>

                  <div class="stat-block">
                    <div class="stat-label red-dot">{{ $t('Disconnected') }}</div>
                    <div class="stat-value">{{ donutSeries[1] ? donutSeries[1] : '-' }}</div>
                    <!-- <div class="stat-sub">({{ disconnPer }}%)</div> -->
                  </div>
                  <!-- <div class="stat-block">
                    <div class="stat-label green-dot">Bad Signal</div>
                    <div class="stat-value">{{ donutSeries[2] }}</div>
                    <div class="stat-sub">({{ badSignalPer }}%)</div>
                  </div> -->
                </div>

                <!-- <div class="bottom-info mt-16 pa-4">
                  <div class="d-flex align-center"><img src="@/assets/img/assignedIcon.svg" class="mr-1"
                      width="15" /><span>Assigned
                      <b>{{ assignedDevices }}</b></span></div>
                  <div class="d-flex align-center"><img src="@/assets/img/unassignedIcon.svg" class="mr-1"
                      width="15" /><span>Unassigned <b>{{ unassignedDevices }}</b></span></div>
                </div> -->
              </div>
            </div>
          </v-card>
        </div>
      </v-col>

      <!-- RIGHT CARD -->
      <v-col cols="6">
        <v-card class="dashboard-box pa-6">
          <div class="card-title mb-2">{{ $t('Capture Command') }}</div>
          <!--
          <div class="chart-container">
            <apexchart type="bar" width="100%" height="100%" :options="chartOptions" :series="chartSeries" /> -->
          <!-- </div> -->
          <div class="chart-container">
            <template v-if="hasChartData">
              <apexchart type="bar" width="100%" height="100%" :options="chartOptions" :series="chartSeries" />
            </template>
            <div v-else class="empty-chart-state">
              <i class="mdi mdi-chart-bar empty-icon"></i>
              <p class="empty-text">{{ $t('No data available') }}</p>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-container fluid>
      <v-row class="pa-0 ma-0">
        <v-col cols="2" class='d-flex align-center justify-center pb-0'>
          <v-menu v-model="menuOpen" offset-y :close-on-content-click="false" content-class="columnMenu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn text small class="manage-btn btn" v-bind="attrs" v-on="on">
                {{ $t("Manage Columns") }}
                <v-icon right :class="{ rotate: menuOpen }">
                  mdi-chevron-down
                </v-icon>
              </v-btn>
            </template>
            <v-card class="column-card">
              <v-card-title class="column-header">
                {{ $t("Select Columns") }}
              </v-card-title>
              <v-divider />
              <v-list dense class="select-all">
                <v-list-item>
                  <v-checkbox :input-value="isAllSelected" @change="toggleSelectAll" hide-details />
                  <v-list-item-title>
                    {{ $t("Select All") }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
              <v-divider />
              <v-card-text class="column-list">
                <v-list dense>
                  <v-list-item v-for="header in headers.slice(1)" :key="header.value">
                    <v-checkbox v-model="visibleColumns" :value="header.text" hide-details />
                    <v-list-item-title class="column-text">
                      {{ header.text }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card-text>
              <v-divider />
              <v-card-actions class="column-footer">
                <v-btn color="error" style="background: #c57171;color: #ffffff !important;width:80px" text small
                  @click="menuOpen = false">
                  {{ $t("Cancel") }}
                </v-btn>
                <v-spacer />
                <v-btn color="primary" small style="width:80px" @click="menuOpen = false; saveVisibleColumns()">
                  {{ $t("Save") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-col>
        <v-col cols="1" class="d-flex align-center justify-center pa-0 mt-6">
          <v-divider vertical></v-divider>
        </v-col>
        <v-col cols="9" class="d-flex flex-column">
          <section class="searchArea d-flex">
            <v-text-field v-model="searchBy.cameraID" :label="$t('Camera ID')" :placeholder="$t('Camera ID')"
              class="form-input" style="width: 20%;" outlined dense hide-details clearable></v-text-field>
            <v-select v-model="searchBy.floor" :items="floors" :label="$t('Floor')" :placeholder="$t('Select Floor')"
              class="form-select ml-3" style="width: 20%;" clearable outlined dense persistent-hint
              hide-details></v-select>
            <!-- <v-select v-model="searchBy.section" :items="sectionItems" :label="$t('Opposite Section')"
              :placeholder="$t('Select Opposite Section')" class="form-select ml-3" item-title="text" item-value="value"
              style="width: 20%;" clearable outlined dense persistent-hint hide-details></v-select> -->
            <v-select v-model="searchBy.status" :items="statusList" :label="$t('Status')"
              :placeholder="$t('Select Status')" item-text="text" item-value="value" class="form-select ml-3" style="width: 20%;" clearable outlined dense
              persistent-hint hide-details></v-select>
            <v-select v-model="searchBy.connection" :items="connectionList" :label="$t('Connection')"
              :placeholder="$t('Select Connection')" item-text="text" item-value="value" class="form-select ml-3" style="width: 20%;" clearable outlined
              dense persistent-hint hide-details></v-select>
            <v-btn @click="search()" class="btn type-search ml-10" text style="width:120px;">
              {{ $t("Search") }}
            </v-btn>
          </section>
          <section class="searchArea d-flex">
            <v-select v-model="searchBy.battery" :items="batteryList" :label="$t('Battery')" :placeholder="$t('Select Battery value')"
              item-text="text" item-value="value" class="form-input" style="width: 20%;" outlined dense hide-details clearable></v-select>
            <v-select v-model="searchBy.signal" :items="signalList" :label="$t('Signal Strength')"
              :placeholder="$t('Select Signal Strength')" item-text="text" item-value="value" class="form-select ml-3" style="width: 20%;" clearable
              outlined dense persistent-hint hide-details></v-select>
            <v-text-field v-model="searchBy.shelfGroup" :label="$t('Shelf Group ID')" :placeholder="$t('Input Shelf Group ID')"
              class="ml-3 form-input" style="width: 20%;" outlined dense hide-details clearable></v-text-field>
            <!-- <v-text-field v-model="searchBy.shelfName" :label="$t('Shelf Name')" :placeholder="$t('Input Shelf Name')"
              class="ml-3 form-input" style="width: 20%;" outlined dense hide-details clearable></v-text-field> -->
            <v-btn @click="clear()" class="btn type-search ml-10" text style="width:120px">
              {{ $t('Clear') }}
            </v-btn>
          </section>
        </v-col>
      </v-row>

      <!-- 📊 Table -->
      <v-data-table item-key="labelCode" :headers="filteredHeaders" :items="tableData" :hide-default-footer="true"
        :items-per-page="10" fixed-header v-model="selected" single-select show-select class="tbl-type01 mt-10 products"
        :options.sync="options">
        <template v-slot:[`item.updateStatus`]="{ item }">
          <v-tooltip v-if="item.updateStatus === 'TIMEOUT'" top content-class="v-tooltip-resize2">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" v-bind:class="statusStyle(item.updateStatus)">
                <b>{{ $t(item.updateStatus) }}* </b>
              </span>
            </template>

            <div class="tooltip-content">
              <span>{{ item.statusMessage || "No response" }}</span>
            </div>
          </v-tooltip>

          <span v-else v-bind:class="statusStyle(item.updateStatus)">
            {{ $t(item.updateStatus) }}
          </span>
        </template>

        <template v-slot:[`item.battery`]="{ item }">
          <span :class="item.battery === 'GOOD' ? 'txt-stable' : 'txt-danger'">{{ item.battery }}</span>
        </template>

        <template v-slot:item.networkStatus="{ item }">
          <v-tooltip top content-class="tooltip-content">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on" class="status-dot ml-8"
                :class="item.networkStatus === false ? 'offline' : 'online'" />
            </template>
            <span>
              {{
                item.networkStatus === false
                  ? "Offline"
                  : "Online"
              }}
            </span>
          </v-tooltip>
        </template>

        <!-- ⏱ Last Capture -->
        <template v-slot:item.lastCaptureTime="{ item }">
          <v-tooltip v-if="item.captureStatus !== 1 && item.captureStatus !== null && item.captureStatus !== undefined" top>
            <template v-slot:activator="{ on, attrs }">
              <span class="d-flex flex-column align-center" style="width: fit-content;" v-bind="attrs" v-on="on">
                <v-chip outlined x-small color='#EA3F65' class="status-chip"><v-icon size="10" class="mr-1">mdi-close</v-icon> {{
                  $t("FAILED")
                }}</v-chip>
                {{ item.lastCaptureTime || "-" }}
              </span>
            </template>
            <span>
              {{
                CAPTURE_STATUS_MAP[item.captureStatus]
                  ? CAPTURE_STATUS_MAP[item.captureStatus].name
                  : ''
              }}
            </span>
          </v-tooltip>
          <span v-else-if="item.captureStatus === null || item.captureStatus === undefined">
            {{ item.lastCaptureTime || "-" }}
          </span>
          <span class="d-flex flex-column align-center" style="width: fit-content;" v-else>
            <v-chip outlined x-small class="status-chip" color='#2ABC4E'><v-icon size="10" class="mr-1">mdi-check-bold</v-icon> {{
              $t("SUCCESS")
            }}</v-chip>
            {{ item.lastCaptureTime || "-" }}
          </span>
        </template>

        <!-- 📄 Details Popup -->
        <template v-slot:item.details="{ item }">
          <v-icon small :disabled="btnDisabledDetails" @click="openDetails(item)">mdi-file-eye</v-icon>
        </template>

        <!-- 📜 History Popup -->
        <template v-slot:item.history="{ item }">
          <v-icon small @click="openHistory(item)">mdi-history</v-icon>
        </template>
      </v-data-table>

      <!-- 🔘 Actions -->
      <v-row class="mt-4">
        <v-col cols="12" class="d-flex justify-space-between align-end">
          <div>
            <v-btn class="btn mr-2" text :disabled="(selected.length === 0) || btnDisabledDetails" @click="captureNow()">
              <v-icon left>mdi-camera</v-icon>
              {{ $t('Capture Now') }}
            </v-btn>
            <v-btn class="btn mr-2" text :disabled="btnDisabledExport || (tableData.length === 0)" @click="exportRecords()">{{ $t('Export') }}</v-btn>
            <v-btn class="btn unassign mr-2" text @click="unlinkDevice" :disabled="(selected.length !== 1) || btnDisabledDetails">{{ $t('Unassign') }}</v-btn>
            <v-btn class="btn delete mr-2" text @click="deleteDevice" :disabled="(selected.length !== 1) || btnDisabledDetails">{{ $t('Delete') }}</v-btn>
            <v-btn class="btn schedule mr-2" text :disabled="btnDisabledDetails" @click="captureScheSetting()">{{
              $t("Schedule Settings")
            }}</v-btn>
            <v-btn class="btn mr-2 repeat" text :disabled="btnDisabledDetails" @click="deleteRepeatSchedule()">{{
              $t("Delete Repeat Schedule")
            }}</v-btn>
          </div>
          <div>
            <Pagination @paging="paging($event)" :pageInfoText="pageInfoText" :pageIndex="pageIndex"
              :rowPerPage="rowPerPage" :goToPageInput="goToPageInput" :totalPages="totalPages"
              @updatePage="updatePage($event)"></Pagination>
          </div>
        </v-col>
      </v-row>
      <a ref="link" :style="{ display: 'none' }" />
      <Capture-Schedule-Setting v-if="captureScheduleDetailsDailog"
      :captureScheduleDetailsDailog="captureScheduleDetailsDailog"
      @closeModalCapture="captureScheduleDetailsDailog = false" />

      <!-- 📄 Details Dialog -->
      <v-dialog v-model="detailsDialog" max-width="1100" scrollable persistent>
        <v-card class="popup">
          <!-- HEADER -->
          <v-card-title class="d-flex justify-space-between">
            <h3 class="page-title-bar mb-0">
              <img src="@/assets/img/camera.png" style="margin-right: 10px; width:30px" />{{ $t("Camera Details") }}
            </h3>
          </v-card-title>

          <div class="px-6 pt-4">
            <v-tabs v-model="activeTab" background-color="#001E38" color="#fff" grow @change="handleTabChange"
              class="custom-tabs">
              <v-tab>
                {{ $t("Settings") }}
              </v-tab>
              <v-tab>
                {{ $t("Capture History") }}
              </v-tab>
            </v-tabs>
          </div>

          <!-- BODY -->
          <v-card-text class="details-body pb-0">
            <v-tabs-items v-model="activeTab">
              <v-tab-item>
                <div class="settings-tab-content pb-0">

                  <!-- Camera Info -->
                  <div class="settings-section">
                    <div class="section-header">
                      <span class="section-accent"></span>
                      <span class="section-title">{{ $t("Camera Info") }}</span>
                    </div>
                    <div class="info-grid">
                      <div class="info-item">
                        <v-text-field v-model="detailslabelCode" :label="$t('Camera ID')"
                            :placeholder="$t('Camera ID')" class="form-input" outlined dense hide-details
                            disabled></v-text-field>
                      </div>
                      <div class="info-item">
                        <v-text-field v-model="detailsLocation" :label="$t('Location')" :placeholder="$t('Location')"
                            class="form-input" outlined dense hide-details disabled></v-text-field>
                      </div>
                      <div class="info-item">
                        <v-text-field v-model="detailsConfig" :label="$t('Config')" :placeholder="$t('Config')"
                            class="form-input" outlined dense hide-details disabled></v-text-field>
                      </div>
                      <div class="info-item">
                        <v-text-field v-model="detailsSchedule" :label="$t('Schedule')" :placeholder="$t('Schedule')"
                            class="form-input" outlined dense hide-details disabled></v-text-field>
                      </div>
                      <div class="info-item">
                        <v-text-field v-model="detailsRepeatSchedule" :label="$t('Repeat Schedule')"
                            :placeholder="$t('Repeat Schedule')" class="form-input" outlined dense hide-details
                            disabled></v-text-field>
                      </div>
                    </div>
                  </div>

                  <!-- WiFi Settings -->
                  <div class="settings-section">
                    <div class="section-header">
                      <span class="section-accent"></span>
                      <span class="section-title">{{ $t("WiFi Settings") }}</span>
                    </div>
                    <v-row dense>
                      <v-col cols="6">
                        <v-text-field v-model="detailsSsid" :label="$t('SSID')" :placeholder="$t('SSID')"
                          class="form-input" outlined dense hide-details clearable></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field :value="showPwd ? detailsPassword : '••••••••'"
                          @input="detailsPassword = $event" @click:append="showPwd = !showPwd"
                          :append-icon="showPwd ? 'mdi-eye' : 'mdi-eye-off'" :label="$t('Password')"
                          class="form-input" outlined dense hide-details />
                      </v-col>
                    </v-row>
                  </div>

                  <!-- Upload Settings -->
                  <div class="settings-section">
                    <div class="section-header">
                      <span class="section-accent"></span>
                      <span class="section-title">{{ $t("Upload Settings") }}</span>
                    </div>
                    <v-row dense>
                      <v-col cols="4">
                        <v-text-field v-model="detailsHost" :label="$t('Host URL')" :placeholder="$t('Host URL')"
                          class="form-input" outlined dense hide-details clearable></v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <v-text-field v-model="detailsKey" :label="$t('Key')" :placeholder="$t('Key')"
                          class="form-input" outlined dense hide-details clearable></v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <v-text-field :value="showSecret ? detailsSecret : '••••••••'" @input="detailsSecret = $event"
                          @click:append="showSecret = !showSecret"
                          :append-icon="showSecret ? 'mdi-eye' : 'mdi-eye-off'" :label="$t('Secret')"
                          class="form-input" outlined dense hide-details />
                      </v-col>
                    </v-row>
                  </div>

                  <div class="show-more-toggle">
                    <v-divider class="flex-grow-1"></v-divider>
                    <v-btn text x-small class="toggle-btn mx-3" @click="showMore = !showMore">
                      <v-icon small class="mr-1">{{ showMore ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                      {{ showMore ? $t("Show Less Setting") : $t("Show More Setting") }}
                    </v-btn>
                  </div>

                  <v-expand-transition>
                    <div v-if="showMore" class="settings-section">
                      <div class="section-header">
                        <span class="section-accent"></span>
                        <span class="section-title">{{ $t("Camera Settings") }}</span>
                      </div>
                      <v-row dense>
                        <v-col cols="3">
                          <v-text-field v-model="brightness" :label="$t('Brightness')"
                            :placeholder="$t('Input Brightness(0 ~ 128)')" class="form-input" outlined dense
                            hide-details clearable></v-text-field>
                        </v-col>
                        <v-col cols="3">
                          <v-text-field v-model="contrast" :label="$t('Contrast')"
                            :placeholder="$t('Input Contrast(0 ~ 100)')" class="form-input" outlined dense
                            hide-details clearable></v-text-field>
                        </v-col>
                        <v-col cols="3">
                          <v-select v-model="retryCount" :label="$t('Retry Count')"
                            :placeholder="$t('Enter The Retry Count')" :items="retryCountItems" class="form-select"
                            outlined dense hide-details clearable></v-select>
                        </v-col>
                        <v-col cols="3">
                          <v-select v-model="retryInterval" :label="$t('Retry Interval Count')"
                            :placeholder="$t('Enter The Retry Interval Count')" :items="intervalCountItems"
                            class="form-select" outlined dense hide-details clearable></v-select>
                        </v-col>
                      </v-row>
                    </div>
                  </v-expand-transition>

                </div>
              </v-tab-item>
              <v-tab-item>
                <div class="capture-history">
                  <div class="capture-table-section">
                    <v-data-table :headers="scheduleHeaders" :items="scheduleList" :hide-default-footer="true"
                      :items-per-page="-1" fixed-header height="100%" class="tbl-type01 products images"
                      :item-class="getRowClass" @click:row="rowClick" >
                    <template v-slot:item.status="{ item }">
                      <span>
                        <v-chip
                          outlined
                          x-small
                          :color="item.status === 'SUCCESS' ? '#2ABC4E' : '#EA3F65'"
                          >{{ item.status === 'SUCCESS' ? $t('SUCCESS') : $t('FAILED') }}</v-chip
                        >
                      </span>
                    </template>
                    </v-data-table>
                    <div style="position: relative;" class="mt-2 mr-2">
                      <div class="pageInfo"> {{ capturePageInfoText }} </div>
                      <div>
                        <v-pagination v-model="capturePageIndex" @input="capturePaging($event)"
                          :length="captureTotalPages" :total-visible="5" class="capturePageAlign"></v-pagination>
                      </div>
                    </div>
                  </div>

                  <div class="capture-image-section">
                    <div class="image-preview-wrapper" v-if="captureFailCode === null" style="position: relative;">
                      <v-img v-if="selectedImage && !imageLoadError" :src="selectedImage" contain
                        class="rounded preview-image" @error="handleImageError" @load="imageLoading = false">
                        <template v-slot:placeholder>
                          <div class="d-flex align-center justify-center fill-height">
                            <v-progress-circular indeterminate />
                          </div>
                        </template>
                      </v-img>
                      <div v-else-if="!imageLoading"
                        class="d-flex align-center justify-center grey lighten-3 rounded no-image">
                        {{ $t('No Image Available') }}
                      </div>
                      <div v-if="selectedImage && !imageLoadError" class="fullscreen">
                        <v-btn class="fullscreen-btn" small :disabled="!selectedImage" @click="fullImageDialog = true, imageRotation = 0, imageZoom = 1">
                          <v-icon small>mdi-fullscreen</v-icon>
                        </v-btn>
                      </div>
                    </div>
                    <v-card class="capture-fail-card" v-else>
                      <div>
                        <div class="capture-fail-title mb-4"><v-icon color="#f5a623" size="42">mdi-alert</v-icon>{{
                          $t('CAPTURE ATTEMPT FAILED') }}</div>
                        <div class="capture-fail-body">
                          <div class="capture-fail-code-box">
                            <span class="capture-fail-label">{{ $t('Error Code:') }}</span>
                            <span class="capture-fail-code-value">{{ captureFailCodeText }}</span>
                          </div>
                          <div class="capture-fail-reason-box">
                            <strong>{{ $t('Reason:') }}</strong> {{ captureFailReason }}
                          </div>
                        </div>
                        <div class="capture-fail-actions mt-4">
                          <v-btn class="btn" text @click="retryCapture">
                            <v-icon left small>mdi-camera</v-icon>
                            {{ $t('Retry Capture') }}
                          </v-btn>
                        </div>
                      </div>
                    </v-card>
                  </div>
                </div>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
          <v-card-actions v-if="activeTab === 0" class="details-actions">
            <v-btn class="btn" @click="handleSaveBtnClick()">
              {{ $t("Save") }}
            </v-btn>
            <v-btn class="btn" text @click="closeDetails">
              {{ $t("Cancel") }}
            </v-btn>
          </v-card-actions>
          <v-card-actions v-if="activeTab === 1" class="details-actions mt-6">
            <v-btn class="btn" text @click="closeDetails">
              {{ $t("Close") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
<v-dialog
            v-model="fullImageDialog"
            v-if="fullImageDialog"
            persistent
            :retain-focus="false"
            max-width="900"
            transition="dialog-bottom-transition"
        >
            <v-card class="d-flex flex-column zoom-dialog-card">
                <div style="height: 64px; background-color: #001E38; width: 100%; display: flex; align-items: center; padding: 0 16px;">
                    <v-btn icon dark small :disabled="shelfStatusZoom <= 0.25" @click="zoomOut" :title="$t('Zoom Out')">
                        <v-icon>mdi-magnify-minus-outline</v-icon>
                    </v-btn>
                    <span class="zoom-label">{{ Math.round(shelfStatusZoom * 100) }}%</span>
                    <v-btn icon dark small :disabled="shelfStatusZoom >= 5" @click="zoomIn" :title="$t('Zoom In')">
                        <v-icon>mdi-magnify-plus-outline</v-icon>
                    </v-btn>
                    <v-btn icon dark small @click="resetZoom" :title="$t('Reset Zoom')">
                        <v-icon>mdi-magnify-close</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="handleClose">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>
                <div
                    ref="imageViewport"
                    class="image-viewport"
                    @wheel.prevent="onWheel"
                    @mousedown.prevent="onMouseDown"
                    @mousemove="onMouseMove"
                    @mouseup="onMouseUp"
                    @mouseleave="onMouseUp"
                    :style="{ cursor: isDragging ? 'grabbing' : 'grab' }"
                >
                    <img
                        v-if="selectedImage"
                        class="zoomable-image"
                        :src="selectedImage"
                        :class="{ rotated: isRotated }"
                        :style="{
                            transform: `rotate(${imageRotation}deg) translate(${translateX}px, ${translateY}px) scale(${shelfStatusZoom}) `,
                            transformOrigin: '0 0'
                        }"
                        @load="onImageLoad"
                        @dragstart.prevent
                    />
                    <div v-else class="no-image-placeholder">{{ $t('No Image Available') }}</div>
                </div>
            </v-card>
        </v-dialog>

      <v-dialog v-model="AssignDialog" max-width="1100" scrollable persistent>
        <v-card class="popup">
          <!-- HEADER -->
          <v-card-title class="d-flex justify-space-between">
            <h3 class="d-flex align-center">
              <i class="ico ico-store mr-2"></i>{{ $t("Camera Details") }}
            </h3>
          </v-card-title>

          <v-divider />

          <!-- BODY -->
          <v-card-text style="max-height: 70vh; overflow-y: auto;">
            <v-row>
              <!-- LEFT SIDE -->
              <v-col cols="8">
                <!-- Camera Info -->
                <v-card class="pa-3" style="box-shadow: none;">
                  <p style="font-size: 14px;color: #aaa;" class="tit-label">
                    {{ $t("Camera Info") }}
                  </p>
                  <v-row>
                    <v-col cols="4">
                      <v-text-field v-model="detailslabelCode" :label="$t('Camera ID')" :placeholder="$t('Camera ID')"
                        class="form-input" outlined dense hide-details disabled></v-text-field>
                    </v-col>

                    <v-col cols="4">
                      <v-text-field v-model="detailsLocation" :label="$t('Location')" :placeholder="$t('Location')"
                        class="form-input" outlined dense hide-details disabled></v-text-field>
                    </v-col>
                    <v-col cols="4"> </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4">
                      <v-text-field v-model="detailsConfig" :label="$t('Config')" :placeholder="$t('Config')"
                        class="form-input" outlined dense hide-details disabled></v-text-field>
                    </v-col>

                    <v-col cols="4">
                      <v-text-field v-model="detailsSchedule" :label="$t('Schedule')" :placeholder="$t('Schedule')"
                        class="form-input" outlined dense hide-details disabled></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field v-model="detailsRepeatSchedule" :label="$t('Repeat Schedule')"
                        :placeholder="$t('Repeat Schedule')" class="form-input" outlined dense hide-details
                        disabled></v-text-field>
                    </v-col>
                  </v-row>
                </v-card>

                <!-- WiFi -->
                <v-card class="pa-3" style="box-shadow: none;">
                  <p style="font-size: 14px;color: #aaa;" class="tit-label">
                    {{ $t("WiFi Settings") }}
                  </p>
                  <v-row>
                    <v-col cols="6">
                      <v-text-field v-model="detailsSsid" :label="$t('SSID')" :placeholder="$t('SSID')"
                        class="form-input" outlined dense hide-details clearable></v-text-field>
                    </v-col>

                    <v-col cols="6">
                      <v-text-field :value="showPwd ? detailsPassword : '••••••••'" @input="detailsPassword = $event"
                        @click:append="showPwd = !showPwd" :append-icon="showPwd ? 'mdi-eye' : 'mdi-eye-off'"
                        :label="$t('Password')" class="form-input" outlined dense hide-details />
                    </v-col>
                  </v-row>
                </v-card>

                <!-- Upload -->
                <v-card class="pa-3" style="box-shadow: none;">
                  <p style="font-size: 14px; color: #aaa; " class="tit-label">
                    {{ $t("Upload Settings") }}
                  </p>
                  <v-row>
                    <v-col cols="4">
                      <v-text-field v-model="detailsHost" :label="$t('Host URL')" :placeholder="$t('Host URL')"
                        class="form-input" outlined dense hide-details clearable></v-text-field>
                    </v-col>

                    <v-col cols="4">
                      <v-text-field v-model="detailsKey" :label="$t('Key')" :placeholder="$t('Key')" class="form-input"
                        outlined dense hide-details clearable></v-text-field>
                    </v-col>

                    <v-col cols="4">
                      <v-text-field :value="showSecret ? detailsSecret : '••••••••'" @input="detailsSecret = $event"
                        @click:append="showSecret = !showSecret" :append-icon="showSecret ? 'mdi-eye' : 'mdi-eye-off'"
                        :label="$t('Secret')" class="form-input" outlined dense hide-details />
                    </v-col>
                  </v-row>
                </v-card>

                <!-- Webhook -->
                <v-card class="pa-3" style="box-shadow: none;">
                  <p style="font-size: 14px;color: #aaa; " class="tit-label">
                    {{ $t("Webhook URL Settings") }}
                  </p>
                  <v-text-field v-model="detailsWebhook" :label="$t('Webhook URL')" :placeholder="$t('Webhook URL')"
                    class="form-input mt-2" outlined dense hide-details clearable></v-text-field>
                </v-card>
              </v-col>

              <!-- RIGHT SIDE -->
              <v-col cols="4">
                <v-card class="pa-3" style="box-shadow: none;">
                  <v-data-table :headers="scheduleHeaders" :items="scheduleList" :hide-default-footer="true"
                    :items-per-page="-1" fixed-header class="tbl-type01 mt-13 products" />
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider />

          <!-- FOOTER -->
          <v-card-actions class="justify-center">
            <v-btn class="btn" @click="handleSaveBtnClick()">
              {{ $t("Save") }}
            </v-btn>
            <v-btn class="btn" text @click="detailsDialog = false">
              {{ $t("Cancel") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import Pagenation from '@/mixins/Pagenation'
import Pagination from '@/components/pagination/Pagination.vue'
import EventBus from '@/plugins/eventBus'
import { mapGetters } from 'vuex'
import { getRequestConfig, exportFiles } from '@/plugins/exporter'
// import { setTempObj, getTempObj } from '@/plugins/sessionStorageManager'
import CaptureScheduleSetting from './model/CaptureScheduleSetting.vue'
import commons from '@/plugins/commons'
import codes from '@/plugins/codes'
import debounce from 'lodash/debounce'
// import configs from '@/plugins/configs'
export default {
  name: 'DashboardWidget',
  mixins: [Pagenation],
  components: {
    apexchart: VueApexCharts,
    Pagination,
    CaptureScheduleSetting
  },
  data () {
    return {
      // Donut
      shelfStatusZoom: 1,
      translateX: 0,
      translateY: 0,
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,
      activeTab: 0,
      showMore: false,
      retryCountItems: Array.from({ length: 11 }, (_, i) => i),
      intervalCountItems: Array.from({ length: 61 }, (_, i) => i),
      selectedImage: '',
      selectedRowId: 0,
      fullImageDialog: false,
      imageLoadError: false,
      imageLoading: false,
      imageRotation: 0,
      imageZoom: 1,
      isCtrlHeld: false,
      capturePageIndex: 1,
      captureRowPerPage: '10',
      captureTotalPages: 0,
      captureGoToPageInput: 1,
      capturePageInfoText: null,
      donutSeries: [],
      lowBatteryPer: '',
      disconnPer: '',
      badSignalPer: '',
      donutOptions: {
        chart: {
          type: 'donut'
        },

        labels: ['Low Battery', 'Disconnected', 'Bad Signal'],

        colors: ['#d64545', '#ff4d4f', '#CBCBCB'],

        legend: {
          show: false
        },

        dataLabels: {
          enabled: false
        },

        stroke: {
          width: 0
        },

        plotOptions: {
          pie: {
            donut: {
              size: '95%',
              labels: {
                show: true,

                name: {
                  show: true,
                  offsetY: -10,
                  formatter: () => 'Issue Detected'
                },

                value: {
                  show: true,
                  fontSize: 'clamp( 4px, 1vw, 13px)',
                  formatter: () => '100'
                },

                total: {
                  show: true,
                  label: 'Total Devices',
                  fontSize: 'clamp( 4px, 1vw, 13px)',
                  formatter: () => this.totalDevices || 0
                }
              }
            }
          }
        }
      },

      // Mixed Chart
      chartSeries: [
        {
          name: 'Success',
          type: 'bar',
          data: []
        },
        {
          name: 'Failure',
          type: 'bar',
          data: []
        }
      ],

      chartOptions: {
        chart: {
          type: 'bar',
          stacked: true,
          toolbar: { show: false },
          width: '100%'
        },

        stroke: {
          width: 1,
          colors: ['#fff'],
          curve: 'smooth' // ✅ better UI
        },
        colors: ['#1f77b4', '#d64545'],
        plotOptions: {
          bar: {
            columnWidth: '20%'
          }
        },

        markers: {
          size: 4
        },

        xaxis: {
          categories: [],
          tickAmount: 8,
          labels: {
            rotate: 0,
            hideOverlappingLabels: true,
            trim: true,
            showDuplicates: false,
            maxHeight: 120,
            style: {
              fontSize: '12px',
              fontFamily: 'Source Sans Pro, sans-serif'
            },
            formatter: (val) => {
              return val ? val.replace(/-/g, ' - ') : ''
            }
          }
        },

        yaxis: {
          labels: {
            style: {
              fontSize: '12px',
              fontFamily: 'Source Sans Pro, sans-serif'
            }
          }
        },

        dataLabels: {
          enabled: false
        },
        legend: {
          show: true,
          position: 'top',
          horizontalAlign: 'left',
          onItemClick: {
            toggleDataSeries: true
          },
          fontFamily: 'Source Sans Pro, sans-serif'
        },

        grid: {
          strokeDashArray: 0
        },

        responsive: [
          {
            breakpoint: 960,
            options: {
              chart: {
                height: 220
              },
              xaxis: {
                tickAmount: 6,
                labels: {
                  rotate: -45,
                  trim: true,
                  hideOverlappingLabels: true,
                  rotateAlways: true,
                  showDuplicates: false
                }
              }
            }
          },
          {
            breakpoint: 600,
            options: {
              chart: {
                height: 200
              },
              xaxis: {
                tickAmount: 5,
                labels: {
                  rotate: -60,
                  trim: true,
                  hideOverlappingLabels: true,
                  showDuplicates: false,
                  maxHeight: 80
                }
              },
              plotOptions: {
                bar: {
                  columnWidth: '40%',
                  borderRadius: 6,
                  borderRadiusApplication: 'end',
                  barHeight: '70%'
                }
              }
            }
          }
        ]
      },
      menuOpen: false,
      visibleColumns: [],
      captureScheduleDetailsDailog: false,
      statusList: [
        { text: this.$t('SUCCESS'), value: 'SUCCESS' },
        { text: this.$t('PROCESSING'), value: 'PROCESSING' },
        { text: this.$t('TIMEOUT'), value: 'TIMEOUT' }
      ],
      sectionItems: [
        { text: 'Section A', value: 'A' },
        { text: 'Section B', value: 'B' },
        { text: 'Section C', value: 'C' },
        { text: 'Section D', value: 'D' },
        { text: 'Section E', value: 'E' }
      ],
      connectionList: [
        { text: this.$t('ONLINE'), value: 'ONLINE' },
        { text: this.$t('OFFLINE'), value: 'OFFLINE' }
      ],
      batteryList: [
        { text: this.$t('BAD'), value: 'BAD' },
        { text: this.$t('GOOD'), value: 'GOOD' }
      ],
      signalList: [
        { text: this.$t('BAD'), value: 'BAD' },
        { text: this.$t('GOOD'), value: 'GOOD' },
        { text: this.$t('EXCELLENT'), value: 'EXCELLENT' }
      ],
      searchBy: {
        cameraID: null,
        floor: null,
        // section: null,
        status: null,
        connection: null,
        battery: null,
        signal: null,
        shelfGroup: null
        // shelfName: null
      },
      floors: [],
      headers: [
        { text: this.$t('CAMERA ID'), value: 'labelCode', class: 'sti' },
        { text: this.$t('FLOOR'), value: 'floor', sortable: false },
        { text: this.$t('SHELF GROUP ID'), value: 'shelfGroup', sortable: false },
        { text: this.$t('INSTALLED SHELF'), value: 'installedShelf', sortable: false },
        { text: this.$t('MONITORED SHELF'), value: 'linkedShelfIds', sortable: false },
        { text: this.$t('SDK VER'), value: 'cameraSDK', sortable: false },
        { text: this.$t('NEWTON FW'), value: 'firmwareVersion', sortable: false },
        { text: this.$t('CAMERA FW'), value: 'cameraFW', sortable: false },
        { text: this.$t('BATTERY'), value: 'battery', sortable: false },
        { text: this.$t('SIGNAL STRENGTH'), value: 'signal', sortable: false },
        { text: this.$t('CAMERA TYPE'), value: 'cameraType', sortable: false },
        { text: this.$t('STATUS'), value: 'updateStatus', sortable: false },
        { text: this.$t('CONNECTION'), value: 'networkStatus', sortable: false },
        { text: this.$t('LAST CAPTURE TIME'), value: 'lastCaptureTime' },
        { text: this.$t('DETAILS'), value: 'details', sortable: false }
      ],

      tableData: [],

      detailsDialog: false,
      historyDialog: false,
      selectedItem: null,
      page: 1,
      rowPerPage: '10',
      pageIndex: 1,
      pageCount: 0,
      totalPages: 0,
      goToPageInput: 1,
      pageInfoText: null,
      options: {},
      selected: [],
      showPwd: false,
      scheduleList: [],
      scheduleHeaders: [
        { text: '#', value: 'id', width: 50, sortable: false },
        {
          text: this.$t('Capture Time'),
          value: 'lastCaptureTime',
          width: 150,
          sortable: false
        },
        {
          text: this.$t('Status'),
          value: 'status',
          width: 100,
          sortable: false
        }
      ],
      requestConfig: {},
      detailslabelCode: null,
      detailsLocation: null,
      detailsConfig: null,
      detailsSchedule: null,
      detailsRepeatSchedule: null,
      detailsSsid: null,
      detailsPassword: null,
      detailsHost: null,
      detailsKey: null,
      detailsSecret: null,
      detailsWebhook: null,
      showSecret: false,
      AssignDialog: false,
      captureScheduleSettingData: [],
      cameraConfig: {},
      filenameConfig: {},
      brightness: null,
      contrast: null,
      retryCount: null,
      retryInterval: null,
      totalDevices: 0,
      assignedDevices: 0,
      unassignedDevices: 0,
      btnDisabledDetails: null,
      btnDisabledExport: null,
      captureFailCode: null,
      CAPTURE_STATUS_MAP: {
        0: { name: this.$t('CAM_CAPTURE_STATUS_FAIL'), reason: this.$t('The capture command failed due to an unknown or general error.') },
        2: { name: this.$t('CAM_CAPTURE_STATUS_DEVICE_FAIL'), reason: this.$t('The capture device encountered a hardware failure and could not complete the capture.') },
        3: { name: this.$t('CAM_CAPTURE_STATUS_MEMORY_FAIL'), reason: this.$t('The camera failed to allocate or access the memory required to store the captured image.') },
        4: { name: this.$t('CAM_CAPTURE_STATUS_DRIVER_FAIL'), reason: this.$t('A camera driver failure prevented the capture from completing.') },
        5: { name: this.$t('CAM_CAPTURE_STATUS_FLASH_UNLOCK_FAIL'), reason: this.$t('The camera failed to unlock the flash storage before initiating the capture.') },
        6: { name: this.$t('CAM_CAPTURE_STATUS_WIFI_CONNECT_FAIL'), reason: this.$t('The camera could not establish a WiFi connection to proceed with the capture.') },
        7: { name: this.$t('CAM_CAPTURE_STATUS_WIFI_SCAN_FAIL'), reason: this.$t('The camera failed to scan for available WiFi networks before initiating the capture.') },
        8: { name: this.$t('CAM_CAPTURE_STATUS_WIFI_ASSOC_FAIL'), reason: this.$t('The camera failed to associate with the configured WiFi access point.') },
        9: { name: this.$t('CAM_CAPTURE_STATUS_WIFI_PW_FAIL'), reason: this.$t('The camera was rejected by the WiFi network due to an incorrect or missing password.') },
        10: { name: this.$t('CAM_CAPTURE_STATUS_SERVER_SECURITY_FAIL'), reason: this.$t('The camera could not establish a secure connection to the upload server.') },
        11: { name: this.$t('CAM_CAPTURE_STATUS_UPLOAD_FAIL'), reason: this.$t('The camera initiated the capture command but failed to upload the image payload to the server due to a network timeout.') },
        12: { name: this.$t('CAM_CAPTURE_STATUS_CAPTURE_FAIL'), reason: this.$t('The camera initiated the capture but the imaging process failed to complete.') },
        13: { name: this.$t('CAM_CAPTURE_STATUS_SERVER_CONNECT_FAIL'), reason: this.$t('The camera was unable to reach the upload server. Please check the server URL and network connectivity.') },
        14: { name: this.$t('CAM_CAPTURE_STATUS_HTTP_WRITE_FAIL'), reason: this.$t('The camera failed to write data to the HTTP connection during the upload process.') },
        15: { name: this.$t('CAM_CAPTURE_STATUS_HTTP_READ_FAIL'), reason: this.$t('The camera failed to read the HTTP response from the server after initiating the upload.') }
      },
      detailsBucket: null,
      detailsUploadMode: null,
      iso: null,
      blur: null,
      expMode: null,
      expTime: null,
      imgSize: null,
      quality: null,
      obstacleDetectVal: null
    }
  },
  watch: {
    options: {
      handler () {
        this.options.itemsPerPage = Number(this.rowPerPage)
        this.options.page = this.pageIndex
        this.togetDeviceList(this.options.page)
        this.page = 1
      },
      deep: true
    },
    store: {
      handler () {
        if (!this.store.code) {
          EventBus.$emit('openSelectedStores')
          this.tableData = []
          this.totalPages = 0
          this.pageInfoText = null
          this.page = 1
          this.pageIndex = 1
          this.selected = []
          this.searchBy = { cameraID: null, floor: null, status: null, connection: null, battery: null, signal: null, shelfGroup: null }
          this.donutSeries = []
          this.lowBatteryPer = ''
          this.disconnPer = ''
          this.badSignalPer = ''
          this.totalDevices = 0
          this.assignedDevices = 0
          this.unassignedDevices = 0
          this.chartSeries = [{ name: 'Success', type: 'bar', data: [] }, { name: 'Failure', type: 'bar', data: [] }]
          this.floors = []
          return
        }
        this.floors = []
        this.togetCameraStatistics()
        this.togetDeviceList(1)
        this.page = 1
      }
    }
  },
  computed: {
    hasDonutData () {
      return (this.donutSeries || []).some(v => Number(v) > 0)
    },
    hasChartData () {
      return this.chartSeries.some(series =>
        (series.data || []).some(val => Number(val) > 0)
      )
    },
    isAllSelected () {
      return (
        this.headers.length > 0 &&
        this.visibleColumns.length === this.headers.length - 1
      )
    },
    filteredHeaders () {
      return this.headers.filter(
        h => h.value === 'labelCode' || this.visibleColumns.includes(h.text)
      )
    },
    selectedStore () {
      return this.$store.getters['dataStore/GET_SELECTED_STORE'].code
    },
    ...mapGetters({
      store: 'dataStore/GET_SELECTED_STORE'
    }),
    isRotated () {
      return Math.abs(this.imageRotation % 180) === 90
    },
    captureFailCodeText () {
      const entry = this.CAPTURE_STATUS_MAP[this.captureFailCode]
      return entry ? `${entry.name}: ${this.captureFailCode}` : `UNKNOWN_STATUS: ${this.captureFailCode}`
    },
    captureFailReason () {
      const entry = this.CAPTURE_STATUS_MAP[this.captureFailCode]
      return entry ? entry.reason : this.$t('An unexpected error occurred during the capture process.')
    }
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this._onKeyDown)
    window.removeEventListener('keyup', this._onKeyUp)
  },
  mounted () {
    this._onKeyDown = (e) => { if (e.key === 'Control') this.isCtrlHeld = true }
    this._onKeyUp = (e) => { if (e.key === 'Control') this.isCtrlHeld = false }
    window.addEventListener('keydown', this._onKeyDown)
    window.addEventListener('keyup', this._onKeyUp)
    // this.clearTabindex()
    this.$store.dispatch('auth/getDisabledBtn', '14201').then(flag => {
      this.btnDisabledDetails = flag
    })
    this.$store.dispatch('auth/getDisabledBtn', '14202').then(flag => {
      this.btnDisabledExport = flag
    })
    EventBus.$emit('enableSelectedStores', true)
    if (!this.store.code) {
      EventBus.$emit('openSelectedStores')
    } else {
      this.togetCameraStatistics()
      this.togetDeviceList(this.page)
    }
    this.toggleSelectAll(true)
    this.togetCustomCloumn()
  },
  methods: {
    handleClose () {
      this.fullImageDialog = false
    },
    centerImage (imgEl) {
      const viewport = this.$refs.imageViewport
      if (!viewport || !imgEl) return
      const vw = viewport.clientWidth
      const vh = viewport.clientHeight
      const iw = imgEl.naturalWidth
      const ih = imgEl.naturalHeight
      if (!iw || !ih) return
      const fitZoom = parseFloat(Math.min(vw / iw, vh / ih).toFixed(4))
      this.shelfStatusZoom = fitZoom
      this.translateX = (vw - iw * fitZoom) / 2
      this.translateY = (vh - ih * fitZoom) / 2
    },
    onImageLoad (e) {
      this.$nextTick(() => this.centerImage(e.target))
    },
    resetZoom () {
      const viewport = this.$refs.imageViewport
      const img = viewport ? viewport.querySelector('img') : null
      if (img && img.complete && img.naturalWidth) {
        this.centerImage(img)
      } else {
        this.shelfStatusZoom = 1
        this.translateX = 0
        this.translateY = 0
      }
    },
    zoomIn () {
      const newZoom = Math.min(5, parseFloat((this.shelfStatusZoom + 0.25).toFixed(2)))
      const viewport = this.$refs.imageViewport
      if (viewport) {
        const rect = viewport.getBoundingClientRect()
        const cx = rect.width / 2
        const cy = rect.height / 2
        const factor = newZoom / this.shelfStatusZoom
        this.translateX = cx - factor * (cx - this.translateX)
        this.translateY = cy - factor * (cy - this.translateY)
      }
      this.shelfStatusZoom = newZoom
    },
    zoomOut () {
      const newZoom = Math.max(0.25, parseFloat((this.shelfStatusZoom - 0.25).toFixed(2)))
      const viewport = this.$refs.imageViewport
      if (viewport) {
        const rect = viewport.getBoundingClientRect()
        const cx = rect.width / 2
        const cy = rect.height / 2
        const factor = newZoom / this.shelfStatusZoom
        this.translateX = cx - factor * (cx - this.translateX)
        this.translateY = cy - factor * (cy - this.translateY)
      }
      this.shelfStatusZoom = newZoom
    },
    onWheel (e) {
      const step = 0.1
      const direction = e.deltaY < 0 ? 1 : -1
      const newZoom = Math.max(0.25, Math.min(5, parseFloat((this.shelfStatusZoom + direction * step).toFixed(2))))
      if (newZoom === this.shelfStatusZoom) return
      const viewport = this.$refs.imageViewport
      const rect = viewport.getBoundingClientRect()
      const mouseX = e.clientX - rect.left
      const mouseY = e.clientY - rect.top
      const factor = newZoom / this.shelfStatusZoom
      this.translateX = mouseX - factor * (mouseX - this.translateX)
      this.translateY = mouseY - factor * (mouseY - this.translateY)
      this.shelfStatusZoom = newZoom
    },
    onMouseDown (e) {
      this.isDragging = true
      this.dragStartX = e.clientX - this.translateX
      this.dragStartY = e.clientY - this.translateY
    },
    onMouseMove (e) {
      if (!this.isDragging) return
      this.translateX = e.clientX - this.dragStartX
      this.translateY = e.clientY - this.dragStartY
    },
    onMouseUp () {
      this.isDragging = false
    },
    onImageClick (e) {
      if (e.ctrlKey) {
        this.imageZoom = Math.max(0.25, +(this.imageZoom - 0.25).toFixed(2))
      } else {
        this.imageZoom = Math.min(5, +(this.imageZoom + 0.25).toFixed(2))
      }
    },
    closeDetails () {
      this.detailsDialog = false
      this.activeTab = 0
      this.showMore = false
      this.capturePageIndex = 1
      this.captureRowPerPage = '10'
      this.captureTotalPages = 0
      this.captureGoToPageInput = 1
      this.capturePageInfoText = null
      this.selectedImage = ''
      this.selectedRowId = 0
      this.captureFailCode = null
      this.showPwd = false
      this.showSecret = false
    },
    async handleTabChange (tab) {
      if (tab === 1) {
        await this.getCaptureHistory()
      } else {
        await this.toGetCameraDetail()
      }
    },
    rowClick (item) {
      this.selectedRowId = item.id
      if (item.captureStatus !== null && item.captureStatus !== undefined && item.captureStatus !== 1) {
        this.captureFailCode = item.captureStatus
        return
      }
      this.captureFailCode = null
      this.imageLoadError = false
      this.imageLoading = true
      this.selectedImage = ''
      this.$nextTick(() => {
        this.selectedImage = item.image
      })
    },
    getRowClass (item) {
      return item.id === this.selectedRowId
        ? 'selected-row'
        : ''
    },
    handleImageError () {
      this.imageLoading = false
      this.imageLoadError = true
    },
    capturePaging (input) {
      this.captureGoToPageInput = input
      this.getCaptureHistory(input)
    },
    captureScheSetting () {
      this.captureScheduleDetailsDailog = true
    },
    deleteRepeatSchedule () {
      if (!this.store.code) {
        EventBus.$emit('messageAlert', this.$t('Please select a store first.'), 'error')
        return
      }
      this.$utils
        .callAxios(
          codes.requests.toDeleteScheduleSettings.method,
          codes.requests.toDeleteScheduleSettings.url,
          { params: { store: this.store.code } }
        )
        .then(res => {
          if (res.status === 200) {
            EventBus.$emit('messageAlert', this.$t(res.data.returnMsg))
          }
        })
        .catch(error => {
          console.log(error)
          EventBus.$emit(
            'messageAlert',
            this.$t(error.response.data.returnMsg),
            'error'
          )
        })
    },
    captureUpdatePage (event) {
      this.captureRowPerPage = event.toString()
      this.capturePaging(1)
    },
    toggleSelectAll (value) {
      if (value) {
        // select all
        this.visibleColumns = this.headers.map(h => h.text).slice(1)
      } else {
        // clear all
        this.visibleColumns = []
      }
    },
    search () {
      console.log('Search clicked')
      this.togetDeviceList(this.page)
    },
    exportRecords () {
      exportFiles(this.requestConfig, this.$refs.link, 'CameraDeviceList.xlsx')
    },
    getPageInfoText: function (headers) {
      if (headers['x-totalelements'] === '0') {
        return '0 to 0, 0' + ' ' + this.$t('in total')
      }
      return (
        `${headers['x-number'] * 1 * headers['x-size'] + 1} 
      ${this.$t('to')} ${headers['x-number'] * 1 * headers['x-size'] +
        headers['x-total-count'] * 1},
       ${headers['x-totalelements'] * 1}` +
        ' ' +
        this.$t('in total')
      )
    },
    paging (input) {
      this.goToPageInput = input
      this.togetDeviceList(input)
    },
    updatePage (event) {
      this.rowPerPage = event.toString()
      this.paging(1)
    },
    buildParmas () {
      const { sortBy, sortDesc, itemsPerPage } = this.options
      let params = {
        store: this.store.code
      }
      params = this.buildSearchParams(params)
      let sort = null
      if (sortBy.length === 1 && sortDesc.length === 1) {
        const sortKey = sortBy[0]
        const sortOrder = sortDesc[0]
        sort = `${sortKey},${sortOrder ? 'desc' : 'asc'}`
      }
      if (sort !== null) params.sort = sort
      if (itemsPerPage > 0) params.size = this.rowPerPage
      return params
    },
    buildSearchParams: function (params) {
      if (commons.isValidStr(this.searchBy.cameraID)) {
        params.label = this.searchBy.cameraID
      }
      if (commons.isValidStr(this.searchBy.floor)) {
        params.floor = this.searchBy.floor
      }
      if (!commons.isNull(this.searchBy.status)) {
        params.status = this.searchBy.status
      }
      // if (!commons.isNull(this.searchBy.section)) {
      //   params.section = this.searchBy.section
      // }
      if (!commons.isNull(this.searchBy.connection)) {
        params.network = this.searchBy.connection === 'ONLINE'
      }
      if (!commons.isNull(this.searchBy.battery)) {
        params.battery = this.searchBy.battery
      }
      if (!commons.isNull(this.searchBy.signal)) {
        params.signal = this.searchBy.signal
      }
      if (commons.isValidStr(this.searchBy.shelfGroup)) {
        params.shelfGroup = this.searchBy.shelfGroup
      }
      // if (!commons.isNull(this.searchBy.shelfName)) {
      //   params.shelfName = this.searchBy.shelfName
      // }
      return params
    },
    saveRequestConfig: function (config) {
      this.requestConfig = getRequestConfig(config)
    },
    // Fetch device list based on search criteria and pagination
    togetDeviceList: debounce(function (page) {
      this.tableData = []
      const params = this.buildParmas()
      if (page !== null) params.page = page - 1
      const config = { params: params }
      this.$utils
        .callAxios(
          codes.requests.togetDeviceList.method,
          codes.requests.togetDeviceList.url,
          config
        )
        .then(res => {
          this.saveRequestConfig(res.config)
          if (!res.data) return
          this.tableData = res.data.labelList.map(list => {
            list.cameraSDK = list?.cameraSDK || '-'
            list.cameraFW = list?.cameraFW || '-'
            list.firmwareVersion = list?.firmwareVersion || '-'
            list.lastCaptureTime = list.lastCaptureTime
              ? commons.convertDate(list.lastCaptureTime)
              : '-'
            list.installedShelf = list.position && list.position.length
              ? list.position[0].shelfId
              : '-'
            list.shelfGroup = list.shelfGroup ? list.shelfGroup : '-'
            list.floor = list.position?.length
              ? list.position[0].floor
              : '-'
            list.battery = ['GOOD', 'BAD'].includes(list.battery) ? list.battery : '-'
            return list
          })
          if (!this.floors.length) {
            this.floors = [
              ...new Set(
                res.data.labelList
                  .flatMap(item => item.position || [])
                  .map(position => position.floor)
                  .filter(Boolean)
              )
            ]
          }
          this.totalRecords = res.data.labelList.length
          this.pageInfoText = this.getPageInfoText(res.headers)
          this.totalPages = Number(res.headers['x-totalpages'])
          this.selected = []
        })
        .catch(error => {
          this.tableData = []
          this.totalRecords = this.tableItems.length
          const headers = {}
          headers['x-totalelements'] = 0
          this.pageInfoText = this.getPageInfoText(headers)
          this.totalPages = 0
          this.selected = []
          console.debug(`Could not find any  record ${error}`)
        })
    }, 100),
    togetCameraStatistics: debounce(function () {
      // togetCameraStatistics

      const config = { params: { store: this.store.code, period: 'week' } }
      this.$utils
        .callAxios(
          codes.requests.togetCameraStatistics.method,
          codes.requests.togetCameraStatistics.url,
          config
        )
        .then(res => {
          console.log('Camera statistics:', res.data)
          const data = res.data
          const status = data.deviceStatus || {}
          const safeVal = (v) => v === null || v === undefined || v === '' ? '-' : v

          this.donutSeries = [
            safeVal(status.lowBattery) ?? 0,
            safeVal(status.disconnected) ?? 0,
            safeVal(status.badSignal) ?? 0
          ]

          const totalDevices =
            (status.assigned || 0) +
            (status.unassigned || 0)

          this.totalDevices = totalDevices
          this.assignedDevices = status.assigned === null || status.assigned === undefined || status.assigned === '' ? '-' : status.assigned
          this.unassignedDevices = status.unassigned === null || status.unassigned === undefined || status.unassigned === '' ? '-' : status.unassigned

          if (this.totalDevices > 0) {
            this.lowBatteryPer = Number(((status.lowBattery / totalDevices) * 100).toFixed(2))
            this.disconnPer = Number(((status.disconnected / totalDevices) * 100).toFixed(2))
            this.badSignalPer = Number(((status.badSignal / totalDevices) * 100).toFixed(2))
          } else {
            this.lowBatteryPer = '-'
            this.disconnPer = '-'
            this.badSignalPer = '-'
          }

          console.log('Donut Series:', this.donutSeries)

          this.donutOptions = {
            ...this.donutOptions,
            plotOptions: {
              pie: {
                donut: {
                  size: '95%',
                  labels: {
                    show: true,

                    name: {
                      show: true,
                      offsetY: -10,
                      formatter: () => 'Total'
                    },

                    value: {
                      show: true,
                      fontSize: 'clamp( 4px, 1vw, 13px)',
                      offsetY: 10,
                      formatter: (val) => val
                    },

                    total: {
                      show: true,
                      fontSize: 'clamp( 8px, calc(1vw + 5px), 20px)',
                      label: 'Total Devices',
                      formatter: () => totalDevices
                    }
                  }
                }
              }
            }
          }
          const snapshotData = data.snapshotCount || {}
          this.snapshotData = snapshotData
          const categories = Object.keys(snapshotData)
          const formattedCategories = categories.map((date) => {
            const [day, month] = date.split('-')
            return `${month}-${day}`
          })
          this.chartSeries[0].data = categories.map(
            key => snapshotData[key].success || 0
          )

          this.chartSeries[1].data = categories.map(
            key => snapshotData[key].failure || 0
          )
          this.chartOptions = {
            ...this.chartOptions,
            xaxis: {
              ...this.chartOptions.xaxis,
              categories: formattedCategories
            },
            tooltip: {
              shared: false,
              intersect: true,
              custom: ({ series, seriesIndex, dataPointIndex, w }) => {
                const displayCategory = w.config.xaxis.categories[dataPointIndex]
                const category = categories[dataPointIndex]
                const value = series[seriesIndex][dataPointIndex]
                const details =
                  this.snapshotData?.[category]?.failureDetails || {}
                const detailsHtml = Object.keys(details).length
                  ? Object.entries(details)
                    .map(
                      ([key, val]) =>
                        `<div style="font-size:10px; color:#666;">${key}: ${val}</div>`
                    )
                    .join('')
                  : '<div style="font-size:10px; color:#999;">No details</div>'
                if (seriesIndex === 1) {
                  return `
                <div>
                  <div style="background:#001E38;color:#fff;padding:8px"><strong>${displayCategory}</strong></div>
                  <div style="padding:8px;color:#ff4d4f">Failure: ${value}
                  ${detailsHtml}
                  </div>
                </div>
              `
                }
                return `
              <div>
                <div style="background:#001E38;color:#fff;padding:8px"><strong>${displayCategory}</strong></div>
                <div style="padding:8px">Success: ${value}</div>
              </div>
            `
              }
            }
          }
        })
        .catch(error => {
          console.debug(`Could not find any  record ${error}`)
        })
    }, 100),

    toGetCameraDetail: function () {
      const config = { params: {} }
      config.params.store = this.store.code
      config.params.label = this.selectedItem.labelCode

      this.$utils
        .callAxios(
          codes.requests.togetDeviceCameraDetail.method,
          codes.requests.togetDeviceCameraDetail.url,
          config
        )
        .then(res => {
          console.log('Camera details:', res.data)
          const configStatusData = res.data[0].status || {}
          const wifiData = res.data[0].camera_config.wifiConfig || {}
          const uploadData = res.data[0].camera_config.uploadConfig || {}
          console.log('Config Status Data:', configStatusData)
          console.log('WiFi Data:', wifiData)
          console.log('Upload Data:', uploadData)
          this.detailsConfig = configStatusData.config || 'N/A'
          this.detailsSchedule = configStatusData.schedule || 'N/A'
          this.detailsRepeatSchedule = configStatusData.repeatSchedule || 'N/A'
          this.detailsSsid = wifiData.ssid || 'N/A'
          this.detailsPassword = wifiData.password || 'N/A'
          this.detailsHost = uploadData.hostname || 'N/A'
          this.detailsKey = uploadData.key || 'N/A'
          this.detailsSecret = uploadData.secret || 'N/A'
          this.detailsBucket = uploadData.bucket
          this.detailsUploadMode = uploadData.uploadMode
          this.cameraConfig = res.data[0].camera_config.cameraConfig || {}
          this.filenameConfig = res.data[0].camera_config.filenameConfig || {}
          this.brightness = res.data[0].camera_config.cameraConfig.brightness || null
          this.contrast = res.data[0].camera_config.cameraConfig.contrast || null
          this.retryCount = res.data[0].camera_config.cameraConfig.retryCount || null
          this.retryInterval = res.data[0].camera_config.cameraConfig.retryInterval || null
          this.iso = res.data[0].camera_config.cameraConfig.iso
          this.blur = res.data[0].camera_config.cameraConfig.blur
          this.expMode = res.data[0].camera_config.cameraConfig.expMode
          this.expTime = res.data[0].camera_config.cameraConfig.expTime
          this.imgSize = res.data[0].camera_config.cameraConfig.imgSize
          this.quality = res.data[0].camera_config.cameraConfig.quality
          this.obstacleDetectVal = res.data[0].camera_config.cameraConfig.obstacleDetectVal
        })
        .catch(error => {
          console.error('Error fetching camera details:', error)
        })
    },
    getCaptureHistory (page = 1) {
      const config = {
        params: {
          store: this.store.code,
          label: this.selectedItem.labelCode,
          size: this.captureRowPerPage,
          page: page - 1
        }
      }
      this.$utils
        .callAxios(
          codes.requests.togetCameraSnapshots.method,
          codes.requests.togetCameraSnapshots.url,
          config
        )
        .then(res => {
          this.scheduleList = res.data.map((item, index) => ({
            id: index + 1 + ((page - 1) * this.captureRowPerPage),
            lastCaptureTime: commons.convertDate(item.snapshotTs),
            image: item.downloadableUrl,
            status: item.captureStatus === 1 ? 'SUCCESS' : 'FAILED',
            captureStatus: item.captureStatus
          }))
          this.$nextTick(() => {
            if (this.scheduleList.length > 0) {
              const first = this.scheduleList[0]
              this.selectedRowId = first.id
              if (first.captureStatus !== null && first.captureStatus !== undefined && first.captureStatus !== 1) {
                this.captureFailCode = first.captureStatus
              } else {
                this.captureFailCode = null
                this.imageLoadError = false
                this.imageLoading = true
                this.selectedImage = first.image
              }
            }
          })
          this.capturePageIndex = page
          this.captureTotalPages = Number(res.headers['x-totalpages'] || 1)

          this.capturePageInfoText =
            this.getPageInfoText(res.headers)
          console.log('Capture history:', this.scheduleList)
        })
        .catch(error => {
          console.error(error)
          this.scheduleList = []
          this.selectedImage = ''
        })
    },
    clear () {
      console.log('Clear clicked')
      this.searchBy = {
        cameraID: null,
        floor: null,
        // section: null,
        status: null,
        connection: null,
        battery: null,
        signal: null,
        shelfGroup: null
        // shelfName: null
      }
      this.togetDeviceList(this.page)
    },
    openDetails (item) {
      console.log('Open details for item:', item)
      this.scheduleList = []
      this.selectedItem = item
      this.detailslabelCode = item?.labelCode
      this.detailsLocation = item.position?.length ? `${item.position[0].floor} | ${item.position[0].shelfName} | ${item.position[0].shelfId}` : '-'
      this.activeTab = 0
      this.toGetCameraDetail()
      console.log('Schedule List:', this.scheduleList)
      console.log('Selected item for details:', item)
      this.detailsDialog = true
    },
    assignDevices () {
      console.log('Assign Devices clicked')
      this.AssignDialog = true
      // Implement the logic to assign devices here
    },
    closeModal () {
      // this.shelfGroupDetailsDailog = false
      this.captureScheduleDetailsDailog = false
    },
    handleSaveBtnClick () {
      // toUpdateDeviceCameraDetail
      this.showPwd = false
      this.showSecret = false
      const config = {
        params: {
          store: this.store.code
        }
      }
      const reqBody = {
        cameraConfigList: [
          {
            labelCode: this.detailslabelCode,
            wifiConfig: {
              ssid: this.detailsSsid,
              keyType: 1,
              password: this.detailsPassword
            },
            uploadConfig: {
              key: this.detailsKey,
              bucket: this.detailsBucket,
              secret: this.detailsSecret,
              hostname: this.detailsHost,
              uploadMode: this.detailsUploadMode
            },
            cameraConfig: {
              iso: this.iso,
              blur: this.blur,
              expMode: this.expMode,
              expTime: this.expTime,
              imgSize: this.imgSize,
              quality: this.quality,
              brightness: this.brightness,
              contrast: this.contrast,
              retryCount: this.retryCount,
              retryInterval: this.retryInterval,
              obstacleDetectVal: this.obstacleDetectVal
            },
            filenameConfig: this.filenameConfig
          }]
      }

      this.$utils
        .callAxiosWithBody(
          codes.requests.toUpdateDeviceCameraDetail.method,
          codes.requests.toUpdateDeviceCameraDetail.url,
          reqBody,
          config
        )
        .then(res => {
          console.log(res)
          if (res.status === 200 || res.status === 201) {
            EventBus.$emit('messageAlert', this.$t(res.data.returnMsg || 'Success'))
            this.detailsDialog = false
          }
        })
        .catch(error => {
          EventBus.$emit(
            'messageAlert',
            this.$t(error.response.data.returnMsg || error.response.data.responseMessage || 'An error occurred while saving the schedule.'),
            'error'
          )
          this.detailsDialog = false
        })
      //
    },
    unlinkDevice () {
      console.log('Selected item for unlinking:', this.selected)
      this.$utils
        .callAxios(
          codes.requests.toUnlinkCameraDevice.method,
          codes.requests.toUnlinkCameraDevice.url,
          {
            params: {
              store: this.store.code,
              labelCode: this.selected[0]?.labelCode || null
            }
          }
        )
        .then(res => {
          if (res.status === 200) {
            EventBus.$emit('messageAlert', this.$t(res.data.returnMsg))
            this.selected = []
            this.togetDeviceList(this.page)
          }
        })
        .catch(error => {
          console.log(error)
          EventBus.$emit(
            'messageAlert',
            this.$t(error.response.data.returnMsg),
            'error'
          )
          this.selected = []
        })
      // Implement the logic to unlink device here
    },

    async deleteDevice () {
      const ok = await this.$confirm.open({
        title: 'Delete Confirmation',
        message: 'Are you sure you want to delete selected camera device?'
      })
      if (!ok) return
      this.$utils
        .callAxios(
          codes.requests.toDeleteCameraDevice.method,
          codes.requests.toDeleteCameraDevice.url,
          {
            params: {
              store: this.store.code,
              labelCode: this.selected[0]?.labelCode || null
            }
          }
        )
        .then(res => {
          if (res.status === 200) {
            EventBus.$emit('messageAlert', this.$t(res.data.returnMsg))
            this.selected = []
            this.togetDeviceList(this.page)
          }
        })
        .catch(error => {
          console.log(error)
          EventBus.$emit(
            'messageAlert',
            this.$t(error.response.data.returnMsg),
            'error'
          )
          this.selected = []
        })
      // Implement the logic to delete device here
    },

    retryCapture () {
      if (!this.selectedItem) return
      const body = [this.selectedItem.labelCode]
      const config = { params: { store: this.store.code } }
      this.$utils
        .callAxiosWithBody(
          codes.requests.toPutCaptureNow.method,
          codes.requests.toPutCaptureNow.url,
          body,
          config
        )
        .then(res => {
          if (res.status === 200) {
            EventBus.$emit('messageAlert', this.$t(res.data.returnMsg))
          }
        })
        .catch(error => {
          EventBus.$emit('messageAlert', this.$t(error.response.data.returnMsg), 'error')
        })
    },

    captureNow () {
      var body = this.selected.map(item => ({
        label: item.labelCode
      }))
      body = body.map(item => item.label)

      console.log(body)
      const params = {
        store: this.store.code
      }
      const config = { params }
      this.$utils
        .callAxiosWithBody(
          codes.requests.toPutCaptureNow.method,
          codes.requests.toPutCaptureNow.url,
          body,
          config
        )
        .then(res => {
          if (res.status === 200) {
            EventBus.$emit('messageAlert', this.$t(res.data.returnMsg))
            this.selected = []
          }
        })
        .catch(error => {
          console.log(error)
          EventBus.$emit(
            'messageAlert',
            this.$t(error.response.data.returnMsg),
            'error'
          )
          this.selected = []
        })
    },
    statusStyle (status) {
      if (status === 'SUCCESS') return 'txt-stable'
      if (status === 'PROCESSING') return 'txt-caution'
      if (status === 'TIMEOUT') return 'txt-danger'
      return ''
    },
    togetCustomCloumn () {
      const params = { userId: this.$store.state.auth.user.account, type: 'DEVICE_LIST' }
      const config = { params: params }
      this.$utils
        .callAxios(
          codes.requests.getCustomColoumnlist.method,
          codes.requests.getCustomColoumnlist.url,
          config
        )
        .then(res => {
          if (res.status === 200) {
            const data = res.data
            const apiColumns = data['14200'] || []
            if (apiColumns.length > 0) {
              this.visibleColumns = apiColumns.filter(text =>
                this.headers.some(h => h.text === text)
              )
            } else {
              this.visibleColumns = []
            }
          } else {
            this.visibleColumns = this.headers.map(h => h.text)
          }
        })
        .catch(error => {
          console.log(error)
          this.visibleColumns = this.headers.map(h => h.text)
        })
    },
    saveVisibleColumns () {
      const body = {
        14200: this.visibleColumns
      }
      const params = { userId: this.$store.state.auth.user.account, type: 'DEVICE_LIST' }
      this.$utils
        .callAxiosWithBody(
          codes.requests.updateCustomColoumnlist.method,
          codes.requests.updateCustomColoumnlist.url,
          body,
          { params: params }
        )
        .then(res => {
          if (res.status === 200) {
            EventBus.$emit('messageAlert', this.$t(res.data.responseMessage))
            this.togetCustomCloumn()
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<style scoped>
/* .text-h5 {
  line-height: 1;
} */
/* Scroll bar stylings */
::v-deep ::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

/* Track */
::v-deep ::-webkit-scrollbar-track {
  background: var(--lightestgrey);
}

/* Handle */
::v-deep ::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 5px;
}

/* Handle on hover */
::v-deep ::-webkit-scrollbar-thumb:hover {
  background: #c1c1c1;
}

::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 5px;
}

.dashboard-row {
  margin-top: 10px;
}

/* Card */
.dashboard-box {
  border-radius: 4px;
  border: 1px solid #dddfe9;
  box-shadow: none !important;
  height: 100%;
}

/* Title */
.card-title {
  font-size: clamp(16px, 1.5vw, 20px);
  font-weight: 600;
  color: #5c5c75;
  margin-bottom: 15px;
}

/* Layout */
.donut-card {
  display: flex;
  flex-direction: column;
}

.device-wrapper {
  display: flex;
  align-items: center;
  gap: 2vw;
  flex: 0.8;
}

/* Donut */
.donut-section {
  width: 100%;
  max-width: clamp(160px, 12vw, 240px);
  /* instead of fixed 220 */
}

/* Stats */
.stats-section {
  flex: 1;
}

/* .stats-row {
  display: flex;
  justify-content: space-between;
} */

/* Stat */
.stat-block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 120px;
  max-width: 300px;
}

.stat-label {
  font-size: 13px;
  color: #7a869a;
  position: relative;
  padding-left: 12px;
}

.yellow-dot::before,
.red-dot::before,
.green-dot::before {
  content: "";
  width: 7px;
  height: 7px;
  position: absolute;
  left: 0;
  top: 6px;
  border-radius: 2px;
}

.yellow-dot::before {
  background: #f4b000;
}

.red-dot::before {
  background: #ff4d6d;
}

.green-dot::before {
  background: #CBCBCB;
}

.stat-value {
  font-size: 24px;
  font-weight: 600;
}

.stat-sub {
  font-size: 12px;
  color: #9aa3b2;
}

/* Divider */
.divider {
  height: 1px;
  background: #e6e8ef;
  margin: 20px 0;
}

/* Bottom */
.bottom-info {
  display: flex;
  justify-content: space-between;
  font-size: clamp(4px, 1vw, 13px);
  color: #6b7280;
  border: 1px solid #d5d7da;
  border-radius: 4px;
  max-width: clamp(325px, 20vw, 470px);
  white-space: nowrap;
}

/* Chart */
.chart-container {
  width: 100%;
  height: 240px;
}

.columnMenu {
  max-width: 260px;
  top: 250px;
}

.column-card {
  width: 100%;
  max-width: 260px;
}

.column-header {
  font-weight: 600;
  font-size: 14px;
  padding: 12px 16px;
}

.column-list {
  max-height: 260px;
  overflow-y: auto;
  padding: 0 8px;
}

.column-text {
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.column-footer {
  position: sticky;
  bottom: 0;
  background: #fff;
  padding: 8px 12px;
}

.manage-btn {
  max-width: 200px;
  white-space: nowrap;
}

.rotate {
  transform: rotate(180deg);
  transition: transform 0.2s ease;
}

.v-input--selection-controls {
  margin-top: 0px !important;
  padding-top: 0px !important;
}

/* .v-btn.type-search::v-deep .v-btn__content {
  margin-top: 15px;
  height: 100%;
} */

::v-deep .v-data-table thead th {
  background-color: #ececec !important;
  white-space: nowrap;
}

.empty-chart-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  color: #999;
  background: #F9F9F9;
  border-radius: 4px;
}

.empty-icon {
  font-size: 48px;
}

.empty-text {
  font-size: 13px;
  font-weight: 500;
  margin: 0 0 8px 0;
  color: #666;
}

.empty-subtext {
  font-size: 14px;
  margin: 0;
  color: #999;
}

.dashboard-scroll {
  width: 100%;
  height: 100%;
}

.capture-history {
  display: flex;
  height: 49vh;
  gap: 10px;
  padding: 16px 0;
}

.capture-table-section {
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.capture-table-section .v-data-table {
  height: 77.8%;
}

.capture-image-section {
  width: 52%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.image-preview-wrapper {
  flex: 1;
  overflow: hidden;
  border: 1px solid #e6e8ef;
}

.preview-image,
.no-image {
  background-color: transparent !important;
  height: 100%;
}

.fullscreen {
  position: absolute;
  right: 12px;
  top: 6px;
}

.fullscreen-btn {
  background-color: #001e38 !important;
  color: #fff;
  min-width: 32px !important;
}

.reset {
  position: absolute;
  right: 18px;
  bottom: 18px;
}

.reset-btn {
  background-color: #001e38 !important;
  color: #fff;
  min-width: 48px !important;
  min-height: 48px !important;
}

.image-container {
  height: calc(90vh - 48px);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
  position: relative;
}

.image {
  max-width: 70vw;
  max-height: 75vh;
  object-fit: contain;
  transition: transform .3s ease;
  transform-origin: center;
}

.image.rotated {
  max-width: 75vh;
  max-height: 70vw;
}

.status-chip {
  font-size: 8px;
  width: 68px;
  justify-content: center;
  padding: 0;
}

.capture-fail-card {
  flex: 1;
  overflow: auto;
  border: 1px solid #e6e8ef !important;
  padding: 4px 16px 10px;
  border-radius: 4px !important;
  box-shadow: none !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.capture-fail-title {
  font-size: 16px;
  font-weight: 700;
  color: #d64545;
  letter-spacing: 0.5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}
.capture-fail-code-box {
  background: #fdecea;
  border-radius: 6px;
  padding: 10px 14px;
  font-size: 13px;
  color: #333;
}
.capture-fail-label {
  font-weight: 700;
  display: block;
}
.capture-fail-code-value {
  font-family: monospace;
  font-size: 13px;
}
.capture-fail-reason-box {
  padding: 10px 14px;
  font-size: 12px;
  line-height: 1.5;
}
.capture-fail-actions {
  text-align: center;
}

@media (max-width: 1640px) {
  .donut-card {
    overflow-x: auto;
  }

  .donut-card {
    flex-wrap: nowrap !important;
    width: 100%;
  }
}

.custom-tabs {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  overflow: hidden;
}

/* ---- Details Dialog ---- */
.details-body {
  max-height: 70vh;
  overflow-y: auto;
}

.settings-tab-content {
  padding: 20px 0 12px;
}

.settings-section {
  background: #f9fafc;
  border: 1px solid #e8eaf0;
  border-radius: 8px;
  padding: 16px 18px;
  margin-bottom: 14px;
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
}

.section-accent {
  display: inline-block;
  width: 3px;
  height: 16px;
  background: #001E38;
  border-radius: 2px;
  margin-right: 8px;
  flex-shrink: 0;
}

.section-title {
  font-size: 11px;
  font-weight: 700;
  color: #001E38;
  letter-spacing: 0.6px;
  text-transform: uppercase;
}

/* Read-only Camera Info grid */
.info-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 20px;
}

.info-item {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 160px;
}

.info-label {
  font-size: 10px;
  color: #8a93a6;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.info-value {
  font-size: 13px;
  color: #2c3e50;
  font-weight: 500;
  background: #fff;
  border: 1px solid #dde1ea;
  border-radius: 6px;
  padding: 6px 10px;
  min-height: 32px;
  line-height: 1.5;
}

.show-more-toggle {
  display: flex;
  align-items: center;
  margin: 2px 0 14px;
}

.toggle-btn {
  font-size: 12px !important;
  color: #5c6a82 !important;
  white-space: nowrap;
  letter-spacing: 0.3px;
}

.details-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.images::v-deep tr {
  cursor: pointer;
}

::v-deep .selected-row td {
  background: #001e38 !important;
  color: #ffffff !important;
}

.status-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.status-dot.online {
  background-color: #9bcde3;
}

.status-dot.offline {
  background-color: #e27070;
}

::v-deep .apexcharts-legend-marker svg {
  border: 2px solid transparent;
  border-radius: 5px;
}

::v-deep .apexcharts-legend-marker {
  height: 14px !important;
  width: 14px !important;
}

::v-deep .apexcharts-legend-series {
  gap: 3px;
}

::v-deep .capturePageAlign {
  float: right;
  margin-top: 20px;
}

/* ------------------ RESPONSIVE ------------------ */

/* Tablet */
@media (max-width: 960px) {
  .device-wrapper {
    flex-direction: column;
    align-items: flex-start;
  }

  .donut-section {
    width: 100%;
    text-align: center;
  }

  .stats-row {
    width: 100%;
    justify-content: space-around;
  }
}

/* Mobile */
@media (max-width: 600px) {
  .card-title {
    font-size: 16px;
  }

  .stat-value {
    font-size: 28px;
  }

  .bottom-info {
    flex-direction: column;
    gap: 6px;
  }

  .chart-container {
    height: 200px;
  }
}

@media ( max-width: 1409px) {
  .delete {
    margin-top: 8px;
  }
}
@media ( max-width: 1246px) {
  .unassign {
    margin-top: 8px;
  }
}
@media (max-width: 1560px) {
  .schedule {
    margin-top: 8px;
  }
}
@media (max-width: 1732px) {
  .repeat {
    margin-top: 8px;
  }
}
</style>
<style>
.v-tooltip-resize {
  width: 200px;
  word-break: break-word;
}

.v-tooltip__content {
  background: #001e38;
  color: #fff;
  margin-left: 0 !important
}

.v-tooltip__content:after {
  content: "";
  display: block;
  width: 0;
  height: 0;
  position: absolute;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-top: 15px solid #001e38;
  left: 50% !important;
  transform: translateX(-50%);
  bottom: -10px;
}

.zoom-dialog-card {
  height: 80vh;
}

.image-viewport {
  flex: 1;
  overflow: hidden;
  position: relative;
  user-select: none;
  -webkit-user-select: none;
    background-color: #ececec;
}

.zoomable-image {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  max-width: none;
  pointer-events: none;
}

.no-image-placeholder {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #aaa;
  font-size: 14px;
}

.zoom-label {
  color: #fff;
  font-size: 13px;
  min-width: 48px;
  text-align: center;
  display: inline-block;
}
</style>
